import { ContractTemplateProps, Milestone } from './Contract.interface';

export interface PaymentMilestoneData {
  condition: string;
  percentage: number;
  milestoneSequence?: number;
}

export const getBaseMilestones = (
  contractorId: string,
  ownerId: string,
  requireInspection: boolean,
): Milestone[] => {
  // Base signing milestones that are always present
  const signingMilestones: Milestone[] = [
    {
      id: 'signing-homeowner',
      sequence: 1,
      assigneeId: ownerId,
      assigneeType: 'homeowner',
      title: 'Contract signature required',
      date: new Date().toISOString(),
      type: 'signing',
      status: 'pending'
    },
    {
      id: 'signing-contractor',
      sequence: 3,
      assigneeId: contractorId,
      assigneeType: 'contractor',
      title: 'Contract signature required',
      date: new Date().toISOString(),
      type: 'signing',
      status: 'pending'
    }
  ];

  // Inspection milestones only included if required
  const inspectionMilestones: Milestone[] = requireInspection ? [
    {
      id: 'inspection-setup',
      sequence: 4,
      assigneeId: contractorId,
      assigneeType: 'contractor',
      title: 'Set Up Inspection Dates',
      date: new Date().toISOString(),
      type: 'inspection',
      status: 'pending',
      description: 'Contractor needs to propose three possible inspection dates'
    },
    {
      id: 'inspection-date-selection',
      sequence: 5,
      assigneeId: ownerId,
      assigneeType: 'homeowner',
      title: 'Select Inspection Date',
      date: new Date().toISOString(),
      type: 'inspection',
      status: 'pending',
      description: 'Please select one of the proposed inspection dates'
    },
    {
      id: 'post-inspection-contractor',
      sequence: 6,
      assigneeId: contractorId,
      assigneeType: 'contractor',
      title: 'Contractor Post-Inspection Decision',
      date: new Date().toISOString(),
      type: 'inspection',
      status: 'pending',
      description: 'Contractor must either remove the property inspection contingency or request contract changes'
    },
    {
      id: 'post-inspection-homeowner',
      sequence: 7,
      assigneeId: ownerId,
      assigneeType: 'homeowner',
      title: 'Homeowner Review of Post-Inspection Decision',
      date: new Date().toISOString(),
      type: 'inspection',
      status: 'pending',
      description: 'Review and approve contractor\'s post-inspection decision'
    }
  ] : [];

  return [...signingMilestones, ...inspectionMilestones];
};

export const createPaymentMilestones = (
  paymentSchedule: PaymentMilestoneData[],
  contractPrice: number,
  contractorId: string,
  ownerId: string,
): Milestone[] => {
  return paymentSchedule.map((payment, index) => ({
    id: `payment-${payment.milestoneSequence || index + 1}`,
    sequence: payment.milestoneSequence || (8 + index),
    title: payment.condition,
    date: new Date().toISOString(),
    type: 'payment',
    amount: (contractPrice * payment.percentage) / 100,
    status: 'pending',
    assigneeId: ownerId,
    assigneeType: 'homeowner',
    description: `Payment of ${payment.percentage}% of contract value ($${((contractPrice * payment.percentage) / 100).toFixed(2)})`
  }));
};